import React, { FC } from "react";

import { toDateString } from "~/libs";

import {
  useApisMembersTodaysInsightPostsIndex,
  useApisMembersAiGeneratedEmployeeChallengeShow,
} from "~/hooks";

import { KagaminMessage } from "~/components/organisms";

import { InsightPostTypeType, InsightPostTypes } from "~/domains";

type PropsType = {
  type: InsightPostTypeType["type"];
  className?: string;
};

const NoDataMessage = {
  [InsightPostTypes.MEMO.type]:
    "あなたのノートのように仕事の気付きや思いなどのメモを投稿してみましょう",
  [InsightPostTypes.INTERNAL_QUESTION.type]:
    "ブログ・Q＆Aにアップされた情報を参考にして、社内の質問に回答します",
  [InsightPostTypes.CHALLENGE.type]:
    "あなたの「現在の課題」にチャレンジした結果や気づきをメモしてください",
};

export const TodaysInsightPost: FC<PropsType> = ({
  type,
  className = "",
}: PropsType) => {
  const { data: todaysInsightPostData } = useApisMembersTodaysInsightPostsIndex(
    {
      params: { postType: type },
      config: {
        enabled: type === InsightPostTypes.MEMO.type,
      },
    },
  );

  const { data: aiGeneratedEmployeeChallengeData } =
    useApisMembersAiGeneratedEmployeeChallengeShow({
      config: {
        enabled: type === InsightPostTypes.CHALLENGE.type,
      },
    });

  const DataMessage = {
    [InsightPostTypes.CHALLENGE.type]:
      aiGeneratedEmployeeChallengeData?.aiGeneratedEmployeeChallenge?.challenge,
    [InsightPostTypes.MEMO.type]:
      todaysInsightPostData?.insightPost?.contentText,
    [InsightPostTypes.INTERNAL_QUESTION.type]:
      NoDataMessage[InsightPostTypes.INTERNAL_QUESTION.type],
  };

  const displayText = DataMessage[type] || NoDataMessage[type];

  const subtitle = todaysInsightPostData?.insightPost
    ? `かがみんのメッセージ (過去のメモログの抜粋：${toDateString(new Date(todaysInsightPostData.insightPost?.postDate ?? ""))})`
    : undefined;

  const link = todaysInsightPostData?.insightPost
    ? {
        url: `/insight_posts/${todaysInsightPostData.insightPost.id}`,
        text: "元のメモログを見る",
      }
    : undefined;

  return (
    <KagaminMessage
      message={displayText}
      subtitle={subtitle}
      link={link}
      className={className}
    />
  );
};
